import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export interface passwordStrengthProps {
  password: string;
  onPasswordScoreChange: (passwordScore: number) => void;
}

function PasswordStrength({
  password,
  onPasswordScoreChange,
}: passwordStrengthProps) {
  const { t } = useTranslation('login');
  const [passwordScore, setPasswordScore] = useState(0);

  useEffect(() => {
    const passwordScore = calculatePasswordScore(password);
    setPasswordScore(passwordScore);
    onPasswordScoreChange(passwordScore);
  }, [password, onPasswordScoreChange]);

  const calculatePasswordScore = (password: string): number => {
    if (/^\d+$/.test(password)) {
      return 1;
    }

    const lengthScore = password.length >= 8 ? 1 : -1;
    const numberScore = /\d/.test(password) ? 1 : 0;
    const upperCaseScore = /[A-Z]/.test(password) ? 1 : 0;
    const specialCharScore = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(
      password
    )
      ? 1
      : 0;

    return lengthScore + numberScore + upperCaseScore + specialCharScore;
  };

  return (
    <div className="text-right">
      <div className="flex -mx-1">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="w-1/4 px-1">
            <div
              className={`h-1 rounded-md transition-colors ${
                i < passwordScore
                  ? passwordScore === 1
                    ? 'bg-error'
                    : passwordScore === 2
                    ? 'bg-alert'
                    : passwordScore === 3
                    ? 'bg-warning'
                    : 'bg-success'
                  : 'bg-gray-200'
              }`}
            ></div>
          </div>
        ))}
      </div>
      <span className="text-caption font-regular text-neutral/75 ">
        {t('set-new-password.password-strength')}
      </span>
    </div>
  );
}

export default PasswordStrength;
